export default "__VITE_ASSET__mafo2Rl2__"